import { i18nTranslationHelper } from '@/i18n'

export namespace AssessmentCompetence {
  const t = {
    enums: i18nTranslationHelper.getTEnums
  }

  export class Enum {
    static readonly SELF_KNOWLEDGE = new Enum(
      1,
      'SELF_KNOWLEDGE',
      t.enums('assessmentCompetence.SELF_KNOWLEDGE.label')
    )

    static readonly SELF_CONTROL = new Enum(
      2,
      'SELF_CONTROL',
      t.enums('assessmentCompetence.SELF_CONTROL.label')
    )

    static readonly CONCENTRATION = new Enum(
      3,
      'CONCENTRATION',
      t.enums('assessmentCompetence.CONCENTRATION.label')
    )

    static readonly COGNITIVE_FLEXIBILITY = new Enum(
      4,
      'COGNITIVE_FLEXIBILITY',
      t.enums('assessmentCompetence.COGNITIVE_FLEXIBILITY.label')
    )

    static readonly TIME_MANAGEMENT = new Enum(
      5,
      'TIME_MANAGEMENT',
      t.enums('assessmentCompetence.TIME_MANAGEMENT.label')
    )

    static readonly SYSTEMATIZATION = new Enum(
      6,
      'SYSTEMATIZATION',
      t.enums('assessmentCompetence.SYSTEMATIZATION.label')
    )

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly label: string
    ) {}
  }

  export const getByName = (name: string): Enum => {
    return Object.values(AssessmentCompetence.Enum).find(type => type.name === name)
  }

  export const getAll = (): Enum[] => {
    return Object.values(AssessmentCompetence.Enum)
  }
}
